import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "modal-export-preview__header" };
const _hoisted_2 = { class: "modal-export-preview__title" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-back-arrow" }, null, -1);
const _hoisted_4 = [
    _hoisted_3
];
const _hoisted_5 = {
    key: 0,
    class: "modal-export-preview__subtitle"
};
const _hoisted_6 = {
    key: 0,
    class: "modal-export-preview__table"
};
const _hoisted_7 = {
    key: 1,
    class: "modal-export-preview__skeleton"
};
const _hoisted_8 = { class: "modal-export-preview__footer" };
const _hoisted_9 = { key: 0 };
import { ref, watch, computed, reactive, h } from 'vue';
import { TableV2SortOrder } from 'element-plus';
import { useStore } from 'vuex';
import { useToast } from 'vue-toastification';
import { fetchPreviewAudience } from '@/features/AudienceManager/data';
import { formatDecimal } from '@/utilities/formatters';
import i18n from '@/i18n';
import AudienceExportationPreviewSkeleton from '@/features/AudienceManager/components/Modals/ExportationAudience/ModalExportPreviewSkeleton.vue';
import InfoCard from '@/components/_atoms/InfoCard.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModalExportPreview',
    props: {
        selectedColumnsKeys: {}
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const toast = useToast();
        const isLoading = ref(false);
        const sortBy = ref({
            key: 'PMWEB_ID',
            order: TableV2SortOrder.DESC,
        });
        const dataTable = reactive({
            rows: [],
            columns: [],
            order: 'PMWEB_ID',
        });
        const showModal = computed(() => store.state.audienceManager.showModal.preview);
        const isVisible = computed({
            get: () => showModal.value,
            set: value => {
                store.commit('audienceManager/UPDATE_VISIBILITY_MODAL', {
                    type: 'preview',
                    value,
                });
            },
        });
        const audienceName = computed(() => store.getters['audienceManager/getAudienceName']);
        const audienceId = computed(() => store.getters['audienceManager/getAudienceId']);
        const totalPeople = computed(() => store.getters['audienceManager/totalPeople']);
        const emptyDataPreview = computed(() => !dataTable.rows.length && !dataTable.columns.length);
        const onSort = (sortParams) => {
            const { key: sortColumnKey, order: sortDirection } = sortParams;
            if (!sortColumnKey || !sortDirection)
                return;
            dataTable.rows.sort((rowA, rowB) => {
                const valueA = rowA[sortColumnKey] ?? '';
                const valueB = rowB[sortColumnKey] ?? '';
                if (valueA < valueB)
                    return sortDirection === 'asc' ? -1 : 1;
                if (valueA > valueB)
                    return sortDirection === 'asc' ? 1 : -1;
                return 0;
            });
            sortBy.value = { ...sortParams };
        };
        const fetchPreviewData = async () => {
            isLoading.value = true;
            await fetchPreviewAudience({
                audienceId: audienceId.value,
                columns: props.selectedColumnsKeys,
                orderBy: 'PMWEB_ID',
            })
                .then(response => {
                if (!response)
                    return;
                const SORT_ARROW_SIZE = 40;
                dataTable.columns = response.columns.map(col => {
                    const baseCharWidth = 8;
                    const padding = 30;
                    const titleLength = col.title?.length || 10;
                    const keyLength = col.key?.length || 10;
                    const maxCellLength = Math.max(...response.rows.map(row => row[col.key]?.length || 0));
                    const maxLength = Math.max(titleLength, keyLength, maxCellLength);
                    const calculatedWidth = maxLength * baseCharWidth + padding + SORT_ARROW_SIZE;
                    return {
                        ...col,
                        width: calculatedWidth,
                        sortable: true,
                        headerCellRenderer: () => h('div', { style: `width: ${calculatedWidth}px; white-space: normal;` }, [
                            h('div', { style: 'font-weight: 600; color: #333;' }, col.title),
                            h('div', { style: 'font-weight: 400; font-size: 10px;' }, col.key),
                        ]),
                        cellRenderer: ({ rowData }) => h('div', { style: `width: ${calculatedWidth}px; white-space: normal;` }, rowData[col.key] || '-'),
                    };
                });
                dataTable.rows = response.rows;
                onSort(sortBy.value);
            })
                .finally(() => {
                isLoading.value = false;
            });
        };
        const closeModalPreview = () => {
            store.commit('audienceManager/UPDATE_VISIBILITY_MODAL', { type: 'preview', value: false });
        };
        const saveExportAudience = () => {
            store.dispatch('audienceManager/saveExportAudience', props.selectedColumnsKeys);
        };
        const exportAudience = () => {
            if (!emptyDataPreview.value) {
                closeModalPreview();
                saveExportAudience();
            }
            else {
                toast.warning(i18n.global.t('audiences.no-people-export'), {
                    timeout: 6000,
                });
            }
        };
        watch(() => isVisible.value, shouldOpen => {
            if (shouldOpen)
                fetchPreviewData();
        });
        return (_ctx, _cache) => {
            const _component_el_table_v2 = _resolveComponent("el-table-v2");
            const _component_el_auto_resizer = _resolveComponent("el-auto-resizer");
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createBlock(_component_el_dialog, {
                modelValue: isVisible.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((isVisible).value = $event)),
                class: _normalizeClass(["modal-export-preview", { 'modal-export-preview--empty': emptyDataPreview.value }]),
                id: "modal-export-preview",
                "append-to-body": "",
                width: "820",
                "close-on-click-modal": false,
                "close-on-press-escape": false
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("h2", _hoisted_2, [
                            _createElementVNode("button", {
                                class: "modal-export-preview__back",
                                onClick: closeModalPreview
                            }, _hoisted_4),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('audiences.exportation.title')), 1)
                        ]),
                        (audienceName.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                                _createTextVNode(_toDisplayString(_ctx.$t('audiences.exportation.audience-preview')) + " ", 1),
                                _createElementVNode("strong", null, _toDisplayString(audienceName.value), 1)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    (!isLoading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_component_el_auto_resizer, { style: { "height": "calc(100vh - 280px)" } }, {
                                default: _withCtx(({ height, width }) => [
                                    _createVNode(_component_el_table_v2, {
                                        columns: dataTable.columns,
                                        data: dataTable.rows,
                                        width: width,
                                        height: height,
                                        fixed: "",
                                        "sort-by": sortBy.value,
                                        onColumnSort: onSort
                                    }, {
                                        empty: _withCtx(() => [
                                            _createVNode(InfoCard)
                                        ]),
                                        _: 2
                                    }, 1032, ["columns", "data", "width", "height", "sort-by"])
                                ]),
                                _: 1
                            })
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(AudienceExportationPreviewSkeleton)
                        ])),
                    _createElementVNode("div", _hoisted_8, [
                        (audienceName.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                                _createTextVNode(_toDisplayString(_ctx.$t('audiences.exportation.audience-size')) + " ", 1),
                                _createElementVNode("b", null, _toDisplayString(_unref(formatDecimal)(totalPeople.value, 1)) + " " + _toDisplayString(_ctx.$t('audiences.exportation.records')), 1)
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("button", {
                            class: "btn",
                            onClick: exportAudience
                        }, _toDisplayString(_ctx.$t('export')), 1)
                    ])
                ]),
                _: 1
            }, 8, ["modelValue", "class"]));
        };
    }
});
